import React, { ReactNode } from "react";
import { cn } from "@/utils/cssHelpers";
import { cva } from "class-variance-authority";
import { Disclosure } from "@headlessui/react";
import { ChevronUpIcon } from "@/icons/primary";

const accordionVariants = cva('font-sans-serif bg-white shadow-sm relative px-8', {
  variants: {
    rounded: {
      sm: 'rounded-sm',
      base: 'rounded-base',
      lg: 'rounded-lg',
    }
  }
});

export type CaAccordionProps = {
  title?: string | ReactNode;
  descriptionTitle?: string | ReactNode;
  icon?: ReactNode;
  children: React.ReactNode;
  className?: string;
  rounded?: 'sm' | 'base' | 'lg';
  initialShow?: boolean;
};

function CaAccordion({
  title,
  descriptionTitle,
  icon,
  children,
  className,
  rounded = "base",
  initialShow,
}: CaAccordionProps) {
  return (
    <Disclosure as="div" className={cn(accordionVariants({ rounded }), className)} defaultOpen={initialShow}>
      {({ open }) => (
        <>
          <Disclosure.Button as="div" className="flex justify-between items-center py-8 relative cursor-pointer">
            <div className='flex items-center'>
              {icon && <div>{icon}</div>}
              {title && (
                <div
                  className={cn(`flex flex-col`, icon && "ml-5")}
                  style={{ maxHeight: "72px" }}
                >
                  <div className='text-base font-semibold'>{title}</div>
                  {descriptionTitle && (
                    <div className='text-sm text-mid-neutral-1'>{descriptionTitle}</div>
                  )}
                </div>
              )}
            </div>
            <ChevronUpIcon
              className={cn(open ? 'rotate-180' : '')}
              style={{ fontSize: '24px' }}
            />
          </Disclosure.Button>
          <Disclosure.Panel>
            <div className='pb-8'>{children}</div>
          </Disclosure.Panel>
        </>
      )}
    </Disclosure>
  );
}

export default CaAccordion;
